export default __webpack_public_path__ + "static/media/canada_flag_icon.4b117587.png";